import React, { useMemo } from 'react';
import { View } from 'react-native';
import { aggregateSpendingBreakdownByMonth, MONTH_INITIALS, } from '../../../utils/utils';
import { Label } from './Label';
import { BreakdownBarChart, RunningSumLineChart } from './Charts';
import { makeLineChartData } from './types';
function undoRunningSum(runningSum) {
    return Array.from({ length: runningSum.length }, (_, index) => Math.max(0, index > 0 ? runningSum[index] - runningSum[index - 1] : runningSum[index]));
}
function makeBarChartData(steps, color) {
    return {
        data: undoRunningSum(steps.map((step) => step.cumulative)),
        color,
    };
}
const HorizontalAxisLabels = React.memo(() => (
// Evenly distributed. Ignore the right-inset of the chart.
<View style={styles.container}>
    {MONTH_INITIALS.map((m, i) => (<View key={i} style={styles.label}>
        <Label text={m}/>
      </View>))}
  </View>));
const YearlyBreakdownChart = ({ previous, previousColor, current, currentColor, currency, }) => {
    const prev = useMemo(() => (previous ? aggregateSpendingBreakdownByMonth(previous) : undefined), [previous]);
    const curr = useMemo(() => aggregateSpendingBreakdownByMonth(current), [current]);
    return (<>
      <BreakdownBarChart previous={prev ? makeBarChartData(prev, previousColor) : undefined} current={makeBarChartData(curr, currentColor)} currency={currency}/>
      <HorizontalAxisLabels />
    </>);
};
const YearlyChart = ({ showRunningSum, ...props }) => {
    if (!showRunningSum) {
        return <YearlyBreakdownChart {...props}/>;
    }
    const { previous, previousColor, current, currentColor, currency } = props;
    return (<>
      <RunningSumLineChart previous={previous ? makeLineChartData(previous, previousColor) : undefined} current={makeLineChartData(current, currentColor)} currency={currency}/>
      <HorizontalAxisLabels />
    </>);
};
const styles = {
    container: {
        flexDirection: 'row',
    },
    label: {
        flex: 1,
    },
};
export default YearlyChart;
